import { render, staticRenderFns } from "./areasInteresse.vue?vue&type=template&id=ea5be528"
import script from "./areasInteresse.vue?vue&type=script&lang=js"
export * from "./areasInteresse.vue?vue&type=script&lang=js"
import style0 from "./areasInteresse.vue?vue&type=style&index=0&id=ea5be528&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports